<template>
    <div class="row">
        <div class="d-md-none slide-popin-modal">
            <slide-popin-modal-filter
                :id="'slide-filters-reviews-modal'"
                :aria-labelledby="'slide-filters-reviews'"
                :with-close-button="false"
            >
                <device-filter-reviews
                    device="mobile"
                    :loading="deviceFilterReviews.loading"
                    :reviews-messages="reviewsMessages"
                    :ratings-filter-check-boxes="ratingsFilterCheckboxes"
                    :date-sort-radio-buttons="dateSortRadioButtons"
                    @change-check-box-ratings-filter="updateRatingsFilterHandler"
                    @review-date-sort-item-click="reviewDateSortHandler"
                />
            </slide-popin-modal-filter>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
            <div class="d-none d-md-block">
                <device-filter-reviews
                    device="desktop"
                    :loading="deviceFilterReviews.loading"
                    :reviews-messages="reviewsMessages"
                    :ratings-filter-check-boxes="ratingsFilterCheckboxes"
                    :date-sort-radio-buttons="dateSortRadioButtons"
                    @change-check-box-ratings-filter="updateRatingsFilterHandler"
                    @review-date-sort-item-click="reviewDateSortHandler"
                />
            </div>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
            <device-details-reviews
                :total-review-count="totalReviewCount"
                :device-reviews="deviceDetailsReviews.reviews"
                :loading="deviceDetailsReviews.loading"
                :reviews-messages="reviewsMessages"
            />
        </div>
        <div class="col-12">
            <div v-if="hasMoreReviews" class="row text-center mt-1">
                <div class="col-12">
                    <ob1-boutons
                        :is-button="true"
                        :label="reviewsMessages.more"
                        :is-secondary="true"
                        @ob1-boutons-click="getMoreDeviceReviews"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DeviceDetailsReviews from "../../common/devicereviews/DeviceDetailsReviews.vue"
import DeviceFilterReviews from "../../common/devicereviews/DeviceFilterReviews.vue"
import SlidePopinModalFilter from "../../common/selector/fragment/SlidePopinModalFilter.vue"

export default {
    name: 'DeviceFilterAndDetailsReviews',
    components: {DeviceDetailsReviews, DeviceFilterReviews, SlidePopinModalFilter},
    props: {
        totalReviewCount: {
            type: Number,
            required: true
        },
        deviceDetailsReviews: {
            type: Object,
            required: true
        },
        deviceFilterReviews: {
            type: Object,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
        ratingsFilterCheckboxes: {
            type: Array,
            required: true
        },
        dateSortRadioButtons: {
            type: Array,
            required: true
        },
    },
    computed: {
        hasMoreReviews() {
            return this.deviceDetailsReviews.cursor
        }
    },
    methods: {
        getMoreDeviceReviews() {
            this.$emit('more-device-reviews');
        },
        updateRatingsFilterHandler(selectedRatingsFilter) {
            this.$emit('update-ratings-filter-handler', selectedRatingsFilter);
        },
        reviewDateSortHandler(sortValue) {
            this.$emit('review-date-sort-item-click', sortValue);
        }
    }
}
</script>
